/* unplugin-vue-components disabled */import { render } from "./welfare.vue?vue&type=template&id=51fdb736&scoped=true"
import script from "./welfare.vue?vue&type=script&lang=js"
export * from "./welfare.vue?vue&type=script&lang=js"

import "./welfare.vue?vue&type=style&index=0&id=51fdb736&lang=scss&scoped=true"
import "./welfare.vue?vue&type=style&index=1&id=51fdb736&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fdb736"]])

export default __exports__